import { createFileRoute } from "@tanstack/react-router";
import { CommCenter } from "@/components/comm/comm-center";

export const Route = createFileRoute("/teacher/comms")({ component: () => <CommCenter role="teacher" /> });
